import { styled } from "styled-components";

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  row-gap: 20px;
`;

export const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 5px;
`;

export const InputErrorMessage = styled.p`
  margin: 0;
  color: ${({ theme }) => theme.colors.error};
  font-size: 14px;
`;

export const FormFieldsContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 30px;
  row-gap: 25px;
`;

export const InfoMessageContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  column-gap: 10px;
`;

export const InfoMessage = styled.p`
  font-size: 12px;
  margin: 0;
`;
